import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Moment from 'react-moment';
import 'moment/locale/pt-br';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  margin-bottom: 24px;
  background: #fff;
  border-radius: 3px;
  display: flex;
  overflow: hidden;
  @media (max-width: 540px) {
    display: none;
  }
  a {
    display: flex;
    width: 100%;
    text-decoration: none;
    height: 500px;
    .img {
      background: #3f3f3f;
      display: flex;
      overflow: hidden;
      span {
        height: 100%;
        width: 100%;
        transition: all 0.3s;
        background-position: center;
        background-size: cover;
      }
      @media (min-width: 900px) {
        min-width: 67%;
      }
      @media (min-width: 540px) and (max-width: 900px) {
        min-width: 50%;
      }
    }
    div {
      border-bottom: 6px solid #6A7B43; 
      height: calc(100% - 6px);
      display: flex;
      padding: 0 40px;
      flex-wrap: wrap;
      align-items: center;
      strong {
        display: block;
        margin-top: 14px;
        transition: all 0.3s;
        font: 600 30px Montserrat;
        color: #2D2D2C;
      }
      p {
        font: 14px/24px Montserrat;
        color: #2D2D2C;
        margin: 14px 0 0;
      }
      small {
        color: #545454;
        font: 12px Montserrat;
        margin-top: 20px;
        display: block;
      }
    }
    &:hover {
      .img span {
        transform: scale(1.05);
      }
      strong {
        color: #6A7B43;
      }
    }
  }
`

const Highlight = ({ titulo, subtitulo, data, banner, uid }) => {
  const { language } = useContext(LanguageContext);
  return (
    <Container>
      <Link to={ `/conteudo/${uid}`}>
        <span className="img">
          <span style={ banner && { backgroundImage: `url(${banner.url})` } }></span>
        </span>
        <div>
          <span>
            <strong>
              { titulo && titulo[0].text }
            </strong>
            <p>
              { subtitulo && subtitulo[0].text }
            </p>
            <small>
              <Moment format={ 'LL' } locale={ language }>
                { data }
              </Moment>
            </small>
          </span>
        </div>
      </Link>
    </Container>
  );
}

export default Highlight;
